<template>
  <div class="my-activity" :class="{inApp: $root.$data.isApp}">
    <common-title titleName="我的活动" :bcColor="'#FEFEFF'" :zIndex="1000"/>
    <nav>
      <div v-for="(item) in tabList" :key="item.id" class="tab-item" @click="cutTab(item.id)" :class="{'tab-activity': activityTabId === item.id}">{{item.title}}</div>
    </nav>
    <div class="content">
      <MyGroupBuy v-if="activityTabId === 1"/>
      <PullNew v-if="activityTabId === 2"/>
      <MyGame v-if="activityTabId === 3"/>
    </div>
    <Foot/>
  </div>
</template>

<script>
import CommonTitle from '@/components/header/CommonTitle.vue';
import MyGroupBuy from '@/pages/personalCenter/myActivity/myGroupBuy/MyGroupBuy.vue';
import PullNew from '@/pages/personalCenter/myActivity/pullNew/pullNew.vue';
import MyGame from '@/pages/personalCenter/myActivity/game/MyGame.vue';
import Foot from '@/components/foot/privacy.vue';

export default {
  components: {
    CommonTitle,
    MyGroupBuy,
    PullNew,
    MyGame,
    Foot,
  },
  data() {
    return {
      tabList: [
        {
          title: '拼团',
          id: 1,
        },
        {
          title: '助力',
          id: 2,
        },
        {
          title: '游戏',
          id: 3,
        },
      ],
      activityTabId: 1,
    };
  },
  mounted() {},
  methods: {
    // 切换tab
    cutTab(index) {
      this.activityTabId = index;
    },
  },
};
</script>

<style scoped lang="scss">
.my-activity{
  nav{
    position: fixed;
    top: 100px;
    left: 0;
    z-index: 1000;
    display: flex;
    width: 100%;
    height: 72px;
    padding: 0 36px;
    background: #fff;

    .tab-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 20px 20px 0;
      font-size: 29px;
    }

    .tab-activity {
      position: relative;
      color: $theme_color;

      &::after{
        position: absolute;
        bottom: 0;
        display: block;
        width: 46px;
        height: 5px;
        background: $theme_color;
        border-radius: 18px 18px 0 0;
        content: '';
      }
    }
  }
  .content{
    padding: 172px 36px 0;
  }
}
.inApp {
  nav {
    top: 0;
  }
  .content {
    padding-top: 72px;
  }
}
</style>
